module.exports = __webpack_public_path__ + "img/image98.f4065c78.jpg";